import React, {useEffect} from 'react';

import BackButton from '../../../components/BackButton/BackButton';
import AppButton from '../../../components/Button/AppButton';
import {ArticlePageLayout} from '../../../components/DataDisplay';
import {ComputerBlueIcon} from '../../../components/Icons';
import PopupFullPage from '../../../components/Popup/PopupFullPage';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import analyticsService from '../../../services/analyticsService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import appRouterService from '../../../services/route/appRouterService';
import {hideModalAction} from '../../../state/ducks/modal';
import {dispatch} from '../../../state/store';

const UsbRequiredPopup = ({modalType, deviceName, deviceType}) => {
    const localizedStrings = getLocalizedStrings();
    const titleText = localizedStrings.formatString(
        localizedStrings[localizationKeys.USB_REQUIRED_POPUP_TITLE_TEXT],
        deviceName
    );

    const onBackClick = () => {
        dispatch(hideModalAction(modalType));
    };

    const onConnectAnotherClick = () => {
        analyticsService.pushUsbRequiredConnectAnotherEvent(deviceType);
        appRouterService.forwardToSelectDevice();
        dispatch(hideModalAction(modalType));
    };

    useEffect(() => {
        analyticsService.pushUsbRequiredEvent(deviceType);
    }, []);

    return (
        <PopupFullPage contentLabel={titleText} shouldReturnFocusAfterClose={false}>
            <BackButton onClick={onBackClick} className='absolute left-0 top-0 z-10 md:px-2 xl:px-12' />
            <ArticlePageLayout
                icon={<ComputerBlueIcon className='mb-4 md:h-16 md:w-16' />}
                titleText={titleText}
                descriptionKey={localizationKeys.USB_REQUIRED_POPUP_DESCRIPTION_TEXT}
            >
                <AppButton className='mt-12' tertiary onClick={onConnectAnotherClick}>
                    {localizedStrings[localizationKeys.USB_REQUIRED_POPUP_BUTTON_TEXT]}
                </AppButton>
            </ArticlePageLayout>
        </PopupFullPage>
    );
};

export default UsbRequiredPopup;
